import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Notecards from "@/pages/Notecards";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import StudioLogin from "@/pages/StudioLogin";
import StudioDashboard from "@/pages/StudioDashboard";

function Shell() {
  const { pathname } = useLocation();
  const isStudio = pathname.startsWith("/studio") && pathname !== "/studio/login";
  const lenisRef = useRef(null);

  useEffect(() => {
    let lenis;
    let raf;
    try {
      lenis = new Lenis({ duration: 1.1, smoothWheel: true });
      lenisRef.current = lenis;
      const loop = (t) => {
        lenis.raf(t);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    } catch {
      /* fall back to native scrolling */
    }
    return () => {
      cancelAnimationFrame(raf);
      lenis?.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true, force: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="grain min-h-screen flex flex-col">
      {!isStudio && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/artwork/:id" element={<ArtworkDetail />} />
          <Route path="/notecards" element={<Notecards />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/studio/login" element={<StudioLogin />} />
          <Route path="/studio" element={<StudioDashboard />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isStudio && <Footer />}
      <CartDrawer />
      <Toaster position="bottom-right" toastOptions={{
        style: { background: "#FAF8F5", border: "1px solid rgba(46,42,37,0.12)", color: "#1C1B19", fontFamily: '"Plus Jakarta Sans", sans-serif' },
      }} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Shell />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
